"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.CndzkEntranceApi = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _mtop = _interopRequireDefault(require("./mtop"));
exports.mtop = _mtop["default"];
var _api = _interopRequireDefault(require("./api"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var apiModels = {
  mtop: _mtop["default"],
  api: _api["default"]
};

// sendSDK 支持 @ali/tbjssdk https://yuque.antfin.com/chenghong.qc/prkdcp/bmliq1
var CndzkEntranceApi = function CndzkEntranceApi(options) {
  this.get = void 0;
  this.apis = void 0;
  var _options$apiModel = options.apiModel,
    apiModel = _options$apiModel === void 0 ? 'mtop' : _options$apiModel,
    _options$applicationT = options.applicationType,
    applicationType = _options$applicationT === void 0 ? 'query' : _options$applicationT,
    _options$apiType = options.apiType,
    apiType = _options$apiType === void 0 ? 'cndzk' : _options$apiType,
    _options$cnDataVersio = options.cnDataVersion,
    cnDataVersion = _options$cnDataVersio === void 0 ? '' : _options$cnDataVersio,
    _options$businessId = options.businessId,
    businessId = _options$businessId === void 0 ? '' : _options$businessId,
    _options$realm = options.realm,
    realm = _options$realm === void 0 ? '' : _options$realm,
    sendSDK = options.sendSDK,
    _options$isJsonpForMt = options.isJsonpForMtop,
    isJsonpForMtop = _options$isJsonpForMt === void 0 ? false : _options$isJsonpForMt;
  if (apiModel == 'mtop') {
    var _apiModels$apiModel = apiModels[apiModel],
      apis = _apiModels$apiModel.apis,
      get = _apiModels$apiModel.get;
    this.get = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(apiName, data) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (data === void 0) {
                data = {};
              }
              return _context.abrupt("return", get(apiType, apiName, (0, _extends2["default"])({
                applicationType: applicationType,
                cnDataVersion: cnDataVersion,
                businessId: businessId,
                realm: realm,
                isJsonpForMtop: isJsonpForMtop
              }, data), sendSDK));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    this.apis = apis;
  } else if (apiModel == 'api') {
    var ins = new apiModels['api'](options);
    this.get = ins.get;
    this.apis = ins.apis;
  }
};
exports.CndzkEntranceApi = CndzkEntranceApi;
CndzkEntranceApi.propTypes = {
  apiModel: _propTypes["default"].string,
  applicationType: _propTypes["default"].string,
  apiType: _propTypes["default"].string,
  cnDataVersion: _propTypes["default"].string,
  businessId: _propTypes["default"].string,
  realm: _propTypes["default"].string,
  sendSDK: _propTypes.any,
  isJsonpForMtop: _propTypes["default"].bool
};
var _default = {
  mtop: _mtop["default"],
  CndzkEntranceApi: CndzkEntranceApi
};
exports["default"] = _default;